import { Component, OnInit, OnDestroy } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { HttpErrorResponse, HttpResponse } from '@angular/common/http';

import { NgbActiveModal, NgbModalRef, NgbDateStruct } from '@ng-bootstrap/ng-bootstrap';
import { EventManager, AlertService, JhiLanguageService } from 'ng-jhipster';

import { Student } from './student.model';
import { StudentPopupService } from './student-popup.service';
import { StudentService } from './student.service';
import { Principal, User, UserService, CRUD_ACTIONS } from '../../shared';
import { School, SchoolService } from '../school';
import { Country, CountryService } from '../country';
import { City, CityService } from '../city';

import { studentGlobalLocations } from '../../shared/constants/student.locations.constants';
import { AbstractGeograpicalDialogComponent } from '../abstract-dialog-component/abstract-geopraphical-dialog.component';
import { TaxService } from '../tax';

@Component({
    selector: 'jhi-student-dialog',
    templateUrl: './student-dialog.component.html'
})
export class StudentDialogComponent extends AbstractGeograpicalDialogComponent implements OnInit {


    student: Student;
    authorities: any[];
    isSaving: boolean;
    readonly minDate: NgbDateStruct;

    users: User[];

    constructor(
        public activeModal: NgbActiveModal,
        private jhiLanguageService: JhiLanguageService,
        alertService: AlertService,
        private studentService: StudentService,
        private userService: UserService,
        schoolService: SchoolService,
        private eventManager: EventManager,
        principal: Principal,
        countryService: CountryService,
        cityService: CityService,
        taxService: TaxService
    ) {
        super(countryService, cityService, taxService, schoolService, alertService, principal);
        this.jhiLanguageService.setLocations(studentGlobalLocations);
        this.minDate = { year: 1940, month: 1, day: 1 };
    }

    ngOnInit() {
        this.isSaving = false;
        this.authorities = ['ROLE_USER', 'ROLE_ADMIN'];
        this.loadSchools();

        if (this.principal.hasAnyAuthoritySync(['ROLE_ADMIN']) === true) {
            this.userService.query().subscribe(
                (res: HttpResponse<User[]>) => { this.users = res.body; }, (res: HttpErrorResponse) => this.onError(res));
        } else if (this.student.id) {
            this.userService.findByStudentId(this.student.id).subscribe(
                (res: User) => { this.users = [res]; },
                (res: HttpErrorResponse) => { this.onError(res); }
            );
        } else {
            this.userService.queryUnmanaged().subscribe(
                (res: HttpResponse<User[]>) => { this.users = res.body; }, (res: HttpErrorResponse) => this.onError(res));
        }

        this.loadGeographicalLocations(this.student != null ? this.student.countryId : null);
    }

    clear() {
        this.activeModal.dismiss('cancel');
    }

    save() {
        this.isSaving = true;
        if (this.student.id !== undefined) {
            this.studentService.update(this.student)
                .subscribe((res: Student) =>
                    this.onSaveSuccess(res, CRUD_ACTIONS.UPDATE), (res: HttpErrorResponse) => this.onSaveError(res));
        } else {
            this.studentService.create(this.student)
                .subscribe((res: Student) =>
                    this.onSaveSuccess(res, CRUD_ACTIONS.CREATE), (res: HttpErrorResponse) => this.onSaveError(res));
        }
    }

    private onSaveSuccess(result: Student, action: String) {
        this.eventManager.broadcast({ name: 'studentListModification', content: {
            action: action,
            content: result
        }});
        this.eventManager.broadcast({ name: 'studentModification',  content: {
            action: action,
            content: result
        }});
        this.isSaving = false;
        this.activeModal.dismiss(result);
    }

    private onSaveError(error) {
        this.isSaving = false;
        this.onError(error);
    }

    trackUserById(index: number, item: User) {
        return item.id;
    }

    trackSchoolById(index: number, item: School) {
        return item.id;
    }

    trackCountryById(index: number, item: Country) {
        return item.id;
    }

    trackCityById(index: number, item: City) {
        return item.id;
    }
}

@Component({
    selector: 'jhi-student-popup',
    template: ''
})
export class StudentPopupComponent implements OnInit, OnDestroy {

    modalRef: NgbModalRef;
    routeSub: any;

    constructor(
        private route: ActivatedRoute,
        private studentPopupService: StudentPopupService
    ) { }

    ngOnInit() {
        this.routeSub = this.route.params.subscribe(params => {
            if (params['id']) {
                this.modalRef = this.studentPopupService
                    .open(StudentDialogComponent as Component, params['id']);
            } else {
                this.modalRef = this.studentPopupService
                    .open(StudentDialogComponent as Component);
            }

        });
    }

    ngOnDestroy() {
        this.routeSub.unsubscribe();
    }
}



// WEBPACK FOOTER //
// ./src/main/webapp/app/entities/student/student-dialog.component.ts